import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=1d82a6cc&scoped=true"
import script from "./BaseData.vue?vue&type=script&lang=js"
export * from "./BaseData.vue?vue&type=script&lang=js"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=1d82a6cc&prod&lang=scss&scoped=true"
import style1 from "./BaseData.vue?vue&type=style&index=1&id=1d82a6cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82a6cc",
  null
  
)

export default component.exports